// extracted by mini-css-extract-plugin
export var dateLabel = "_3m-0";
export var dateLabelError = "_3m-1";
export var fullWidth = "_3m-2";
export var smaller = "_3m-3";